module.exports = __webpack_public_path__ + "static/media/GuidelineFuerReisende.e1c695cf.pdf";